/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {RankingAnnualView} from "../../ranking/views/RankingAnnualView";
import {RankingMainView} from "../../ranking/views/RankingMainView";
const route = [
    {webpackEntry: "ranking", path: rpAppPath.ranking.base, component: RankingMainView},
    {webpackEntry: "ranking", path: rpAppPath.ranking.city.base, component: RankingAnnualView},
    {webpackEntry: "ranking", path: rpAppPath.ranking.city.annual, component: RankingAnnualView}
];

(function () {
    rpClient(route);
})();
